import { render, staticRenderFns } from "./ModalMobile.vue?vue&type=template&id=2796df66&scoped=true"
import script from "./ModalMobile.vue?vue&type=script&lang=js"
export * from "./ModalMobile.vue?vue&type=script&lang=js"
import style0 from "./ModalMobile.vue?vue&type=style&index=0&id=2796df66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2796df66",
  null
  
)

export default component.exports